import React from 'react';

import _adviserPortalHome from './_adviserPortalHome';
import AdviserData from './AdviserData';
import AdviserDataRight from './AdviserDataRight';
import TotalMembersComponent from './TotalMembersComponent';
import TotalMembersComponentCopy2 from './TotalMembersComponentCopy2';
import CommissionPaymentComponent from './CommissionPaymentComponent';
import { Container, Row, Col } from 'react-bootstrap';

// import 'bootstrap/dist/css/bootstrap.min.css';

function AdvDashboardBody(props) {
    //const advisers = props.advisers.filter(adviser => adviser.adviserId === props.selectedAdviserId).map(adviser => adviser)
    const adviserDashboardBodyDetails = _adviserPortalHome._adviserDahsboardBodyInDetail(props)
    return (
        // TotalMembers._totalMembersTable({products, total, numAdvisers})

        // <Container fluid>
        //     <Row>
        //         <Col id={!String(props.history.location.pathname).includes("login") ? "adviserDataLeft" : ""}
        //             style={{verticalAlign: "top",width: !String(props.history.location.pathname).includes("login") && "250px"}}>
        //             <AdviserData {...props}
        //                 advisers={props.advisers}
        //                 advisersTotal={props.total}
        //                 products={adviserDashboardBodyDetails.products}
        //                 total={adviserDashboardBodyDetails.total}
        //                 numAdvisers={adviserDashboardBodyDetails.numAdvisers}
        //                 commissionDetails={adviserDashboardBodyDetails.commissionDetails}
        //                 commissionPayments={props.commissionPayments}
        //                 pathname={props.history.location.pathname}
        //                 id={props.id}>
        //             </AdviserData>
        //         </Col>
        //         {
        //                 String(props.history.location.pathname).includes("login") &&
        //                 <Col lg={9} id="adviserDashboard1" style={{ verticalAlign: "top" }}>
        //                     <AdviserDataRight
        //                         advisers={props.advisers}
        //                         advisersTotal={props.total}
        //                         products={adviserDashboardBodyDetails.products}
        //                         total={adviserDashboardBodyDetails.total}
        //                         numAdvisers={adviserDashboardBodyDetails.numAdvisers}
        //                         commissionDetails={adviserDashboardBodyDetails.commissionDetails}>
        //                     </AdviserDataRight>
        //                 </Col>
        //             }

        //             {
        //                 String(props.history.location.pathname).includes("totalMembers") &&
        //                 <Col lg={9} colSpan="3" rowSpan="4" id="adviserDashboard" style={{ verticalAlign: "middle" }}>
        //                     <TotalMembersComponent id={props.id} {...props}></TotalMembersComponent>
        //                 </Col>
        //             }
        //             {
        //                 String(props.history.location.pathname).includes("commissionPayment") &&
        //                 <Col lg={9} id="adviserDashboard" colSpan="3" rowSpan="4" style={{ verticalAlign: "middle", padding: "20px" }}>
        //                     <CommissionPaymentComponent {...props}></CommissionPaymentComponent>
        //                 </Col>
        //             }
        //     </Row>
        // </Container>

        <table className="adviserDashboard">
            <tbody>
                <tr>
                    <td id={!String(props.history.location.pathname).includes("login") ? "adviserDataLeft" : ""}
                        style={{
                            verticalAlign: "top",
                            width: !String(props.history.location.pathname).includes("login") && "250px"
                        }}>
                        <AdviserData {...props}
                            advisers={props.advisers}
                            advisersTotal={props.total}
                            products={adviserDashboardBodyDetails.products}
                            total={adviserDashboardBodyDetails.total}
                            numAdvisers={adviserDashboardBodyDetails.numAdvisers}
                            commissionDetails={adviserDashboardBodyDetails.commissionDetails}
                            commissionPayments={props.commissionPayments}
                            pathname={props.history.location.pathname}
                            id={props.id}>
                        </AdviserData>
                    </td>
                    {
                        String(props.history.location.pathname).includes("login") &&
                        <td id="adviserDashboard1" style={{ verticalAlign: "top" }}>
                            <AdviserDataRight
                                advisers={props.advisers}
                                advisersTotal={props.total}
                                products={adviserDashboardBodyDetails.products}
                                total={adviserDashboardBodyDetails.total}
                                numAdvisers={adviserDashboardBodyDetails.numAdvisers}
                                commissionDetails={adviserDashboardBodyDetails.commissionDetails}>
                            </AdviserDataRight>
                        </td>
                    }

                    {
                        String(props.history.location.pathname).includes("totalMembers") &&
                        <td colSpan="3" rowSpan="4" id="adviserDashboard" style={{ verticalAlign: "middle" }}>
                            <TotalMembersComponentCopy2 id={props.id} {...props}></TotalMembersComponentCopy2>
                        </td>
                    }
                    {
                        String(props.history.location.pathname).includes("commissionPayment") &&
                        <td id="adviserDashboard" colSpan="3" rowSpan="4" style={{ verticalAlign: "middle", padding: "20px" }}>
                            <CommissionPaymentComponent {...props}></CommissionPaymentComponent>
                        </td>
                    }

                </tr>
            </tbody>
        </table>


        //     <div style={{position: "relative"}}>

        //     <TotalFum 
        //         products={adviserDashboardBodyDetails.products} 
        //         total={adviserDashboardBodyDetails.total} 
        //         numAdvisers={adviserDashboardBodyDetails.numAdvisers}/>

        //     <TotalMembers 
        //         products={adviserDashboardBodyDetails.products} 
        //         total={adviserDashboardBodyDetails.total} 
        //         numAdvisers={adviserDashboardBodyDetails.numAdvisers}/>

        //     <CommissionPayment 
        //         commissionDetails={adviserDashboardBodyDetails.commissionDetails}/>

        //     <TotalContributors totalContributors={totalContributors}/>
        //     <TotalNonContributors totalNonContributors={totalNonContributors}/> 
        // </div>
        // <Container> 
        //     <Row>
        //         <Col><TotalMembers 
        //         products={adviserDashboardBodyDetails.products} 
        //         total={adviserDashboardBodyDetails.total} 
        //         numAdvisers={adviserDashboardBodyDetails.numAdvisers}/></Col>
        //         <Col><TotalFum 
        //         products={adviserDashboardBodyDetails.products} 
        //         total={adviserDashboardBodyDetails.total} 
        //         numAdvisers={adviserDashboardBodyDetails.numAdvisers}/></Col>
        //         <Col><CommissionPayment 
        //         commissionDetails={adviserDashboardBodyDetails.commissionDetails}/> </Col>
        //     </Row>
        // </Container>
    )
}

export default AdvDashboardBody;